module.exports = __webpack_public_path__ + "img/porticus.0a4f8343.svg";